import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Dashboard.scss";
import OverViewDetails from "../Dashboard/OverViewDetails/OverViewDetails";
import DashboardSection from "./DashboardSection";
import { LoginDetailsPopup } from "./LoginDetailsPopup";
// import ShapesDemo from "../../Shared/Component/SkeletonLoader";
//Lazy loading for OverViewDetails

const DashboardView = () => {
  const location = useLocation();
  const isNewUser = (location.state && location.state.newUser) || false;
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const handleOpenModal = () => {
    setShowModal(true);
  };
  useEffect(() => {
    if (isNewUser) {
      handleOpenModal();
    }
  }, [isNewUser]);

  const handleCloseModal = () => {
    navigate("/login");
  };
  return (
    <div className="dashboard-content">
      <OverViewDetails />
      <DashboardSection />
      {isNewUser && (
        <LoginDetailsPopup visible={showModal} onClose={handleCloseModal} />
      )}
    </div>
  );
};

export default DashboardView;
